<template>
  <v-carousel height="400" show-arrows="hover" cycle hide-delimiter-background>
    <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src" cover>
    </v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  name: "HomePag",
  data() {
    return {
      items: [
        {
          src: require("@/assets/IA1.jpg"),
        },
        {
          src: require("@/assets/IA2.png"),
        },
        {
          src: require("@/assets/IA3.jpg"),
        },
        {
          src: require("@/assets/IA4.jpg"),
        },
      ],
    };
  },
};
</script>